import React, { memo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface CreateOrganizationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orgName: string;
  orgDescription: string;
  onOrgNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onOrgDescriptionChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onCreate: () => void;
  onCancel: () => void;
}

export const CreateOrganizationDialog = memo(function CreateOrganizationDialog({
  open,
  onOpenChange,
  orgName,
  orgDescription,
  onOrgNameChange,
  onOrgDescriptionChange,
  onCreate,
  onCancel,
}: CreateOrganizationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Criar Nova Organização</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="org-name">Nome</Label>
            <Input
              id="org-name"
              value={orgName}
              onChange={onOrgNameChange}
              placeholder="Nome da organização"
              autoFocus
            />
          </div>
          <div>
            <Label htmlFor="org-description">Descrição (opcional)</Label>
            <Textarea
              id="org-description"
              value={orgDescription}
              onChange={onOrgDescriptionChange}
              placeholder="Descrição da organização"
            />
          </div>
          <div className="flex gap-2 justify-end">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
            >
              Cancelar
            </Button>
            <Button onClick={onCreate} className="w-full">
              Criar Organização
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
});
